import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, renderList as _renderList, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass, withCtx as _withCtx, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  class: "main",
  id: "egcf-speeches-main"
}
const _hoisted_2 = { class: "filter-search-position-container" }
const _hoisted_3 = { class: "filter-button-search-wrapper" }
const _hoisted_4 = { class: "search-input-container" }
const _hoisted_5 = ["placeholder"]
const _hoisted_6 = { class: "button-container" }
const _hoisted_7 = { class: "active-filter-count-bubble" }
const _hoisted_8 = {
  key: 0,
  class: "filter-container"
}
const _hoisted_9 = { class: "filter" }
const _hoisted_10 = ["onUpdate:modelValue"]
const _hoisted_11 = ["value"]
const _hoisted_12 = { class: "select-label" }
const _hoisted_13 = {
  key: 0,
  class: "letter-filter-position-container"
}
const _hoisted_14 = { class: "letter-filter-wrapper" }
const _hoisted_15 = { class: "letter" }
const _hoisted_16 = { class: "letter" }
const _hoisted_17 = { class: "speech-list" }
const _hoisted_18 = { class: "day" }
const _hoisted_19 = ["id"]
const _hoisted_20 = ["id"]
const _hoisted_21 = { class: "speech-content" }
const _hoisted_22 = { class: "speech-start-time" }
const _hoisted_23 = {
  key: 0,
  class: "speech-logo"
}
const _hoisted_24 = ["src"]
const _hoisted_25 = {
  key: 1,
  class: "spacer"
}
const _hoisted_26 = { class: "speech-title" }
const _hoisted_27 = { class: "title" }
const _hoisted_28 = ["onClick"]
const _hoisted_29 = ["onClick"]
const _hoisted_30 = {
  key: 1,
  class: "speech-speakers"
}
const _hoisted_31 = {
  key: 0,
  class: "speaker-container"
}
const _hoisted_32 = { class: "speaker-list" }
const _hoisted_33 = { class: "speaker-header" }
const _hoisted_34 = ["set"]
const _hoisted_35 = ["onClick"]
const _hoisted_36 = { key: 0 }
const _hoisted_37 = {
  key: 1,
  class: "speaker-position"
}
const _hoisted_38 = { key: 0 }
const _hoisted_39 = {
  key: 2,
  class: "speaker-company"
}
const _hoisted_40 = { key: 0 }
const _hoisted_41 = {
  key: 3,
  class: "speaker-country"
}
const _hoisted_42 = { class: "speaker-images" }
const _hoisted_43 = ["onClick", "title"]
const _hoisted_44 = ["innerHTML"]
const _hoisted_45 = {
  key: 3,
  class: "speech-speakers speech-infos"
}
const _hoisted_46 = { class: "speaker-container" }
const _hoisted_47 = ["innerHTML"]
const _hoisted_48 = { class: "speaker-images" }
const _hoisted_49 = {
  key: 0,
  class: "speaker-images-role-container"
}
const _hoisted_50 = ["onClick", "title"]
const _hoisted_51 = { class: "speech-footer" }
const _hoisted_52 = { class: "speech-time-container" }
const _hoisted_53 = ["onClick"]
const _hoisted_54 = {
  key: 0,
  class: "speech-language"
}
const _hoisted_55 = ["onClick"]
const _hoisted_56 = {
  key: 2,
  class: "speech-translation"
}
const _hoisted_57 = {
  key: 3,
  class: "speech-logo"
}
const _hoisted_58 = { key: 0 }
const _hoisted_59 = { key: 1 }
const _hoisted_60 = ["src"]
const _hoisted_61 = {
  key: 1,
  class: "empty-search-results"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading_spinner = _resolveComponent("loading-spinner")!
  const _component_speaker_detail_dialog = _resolveComponent("speaker-detail-dialog")!
  const _component_stand_dialog = _resolveComponent("stand-dialog")!
  const _component_exhibitor_detail_dialog = _resolveComponent("exhibitor-detail-dialog")!
  const _component_qr_code_dialog = _resolveComponent("qr-code-dialog")!
  const _component_lazy_load_container = _resolveComponent("lazy-load-container")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isLoading)
      ? (_openBlock(), _createBlock(_component_loading_spinner, { key: 0 }))
      : _createCommentVNode("", true),
    _createVNode(_component_speaker_detail_dialog, {
      ref: "speakerDetailDialog",
      "get-lang-for-speech": _ctx.getLangForSpeechById
    }, null, 8, ["get-lang-for-speech"]),
    (_ctx.$haveMaps)
      ? (_openBlock(), _createBlock(_component_stand_dialog, {
          key: 1,
          ref: "standDialog"
        }, null, 512))
      : _createCommentVNode("", true),
    (_ctx.exhibitorContainer)
      ? (_openBlock(), _createBlock(_component_exhibitor_detail_dialog, {
          key: 2,
          "open-stand-dialog": _ctx.openStandDialog,
          themes: _ctx.exhibitorContainer.themes,
          ref: "exhibitorDetailDialog",
          "speech-container": _ctx.speechContainer
        }, null, 8, ["open-stand-dialog", "themes", "speech-container"]))
      : _createCommentVNode("", true),
    _createVNode(_component_qr_code_dialog, { ref: "qrCodeDialog" }, null, 512),
    (!_ctx.isLoading)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _withDirectives(_createElementVNode("input", {
                  type: "search",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchValue) = $event)),
                  onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onSearchValueInput && _ctx.onSearchValueInput(...args))),
                  spellcheck: "false",
                  autocapitalize: "none",
                  placeholder: _ctx.$t('search-input-placeholder')
                }, null, 40, _hoisted_5), [
                  [_vModelText, _ctx.searchValue]
                ])
              ]),
              _createElementVNode("div", _hoisted_6, [
                (_ctx.speechFilter.filterExists())
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      (!_ctx.hasActiveFilter())
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            class: "active-filter-button active-filter-button-deactivated",
                            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.toggleFilter && _ctx.toggleFilter(...args)))
                          }, " FILTER "))
                        : (_openBlock(), _createElementBlock("button", {
                            key: 1,
                            class: "active-filter-button active-filter-button-active",
                            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.toggleFilter && _ctx.toggleFilter(...args)))
                          }, [
                            _createElementVNode("span", _hoisted_7, _toDisplayString(Object.entries(_ctx.activeFilters).length), 1),
                            _cache[9] || (_cache[9] = _createTextVNode(" FILTER "))
                          ])),
                      (_ctx.enableFavorites && _ctx.hasFavorites())
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 2,
                            class: "active-filter-button export-qr-code-button",
                            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.openQrCodeDialog($event)))
                          }, [
                            _createTextVNode(_toDisplayString(_ctx.$t("export_favorites")) + " ", 1),
                            _cache[10] || (_cache[10] = _createElementVNode("i", { class: "fas fa-star" }, null, -1))
                          ]))
                        : _createCommentVNode("", true)
                    ], 64))
                  : _createCommentVNode("", true)
              ]),
              (_ctx.isFilterActive)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.speechFilter.filters.ROOT, (filter) => {
                      return (_openBlock(), _createElementBlock("div", _hoisted_9, [
                        _createElementVNode("div", {
                          class: "select",
                          onChange: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.onFilterChanged && _ctx.onFilterChanged(...args)))
                        }, [
                          _withDirectives(_createElementVNode("select", {
                            class: "select-text",
                            required: "",
                            "onUpdate:modelValue": ($event: any) => ((_ctx.activeFilters[filter.id]) = $event)
                          }, [
                            _cache[11] || (_cache[11] = _createElementVNode("option", null, null, -1)),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.speechFilter.filters[filter.id], (option) => {
                              return (_openBlock(), _createElementBlock("option", {
                                value: option.id
                              }, _toDisplayString(option.title), 9, _hoisted_11))
                            }), 256))
                          ], 8, _hoisted_10), [
                            [_vModelSelect, _ctx.activeFilters[filter.id]]
                          ]),
                          _cache[12] || (_cache[12] = _createElementVNode("span", { class: "select-bar" }, null, -1)),
                          _createElementVNode("label", _hoisted_12, _toDisplayString(filter.title), 1)
                        ], 32)
                      ]))
                    }), 256))
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          (_ctx.enableFavorites)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("div", {
                      class: _normalizeClass(_ctx.activeLetterFilter === 'all' ? 'selected': ''),
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.onLetterClicked('all')))
                    }, _toDisplayString(_ctx.$t('all')), 3)
                  ]),
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("div", {
                      class: _normalizeClass(_ctx.activeLetterFilter === 'favorites' ? 'selected': ''),
                      onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.onLetterClicked('favorites')))
                    }, _toDisplayString(_ctx.$t('favorites')), 3)
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_17, [
            (_ctx.speechContainer && _ctx.speechContainer.hasEntries())
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.speechContainer.getSpeechMap(), (speeches, index) => {
                  return (_openBlock(), _createElementBlock("div", _hoisted_18, [
                    _createElementVNode("div", {
                      class: "day-header",
                      id: _ctx.getIdForDate(index)
                    }, _toDisplayString(index), 9, _hoisted_19),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(speeches, (speech) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "speech",
                        id: speech.vueId
                      }, [
                        _createElementVNode("div", _hoisted_21, [
                          _createElementVNode("div", _hoisted_22, [
                            _createElementVNode("span", null, _toDisplayString(speech.timeSpanPrefix), 1),
                            (speech.logo && false)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                                  _createVNode(_component_lazy_load_container, {
                                    ref_for: true,
                                    ref: "lazyLoadingContainer"
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("img", {
                                        src: speech.getLogoUrl()
                                      }, null, 8, _hoisted_24)
                                    ]),
                                    _: 2
                                  }, 1536)
                                ]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_25))
                          ]),
                          _createElementVNode("div", {
                            class: "speech-info-container",
                            style: _normalizeStyle(_ctx.getBorderColorCSS(speech))
                          }, [
                            (speech.category)
                              ? (_openBlock(), _createElementBlock("div", {
                                  key: 0,
                                  class: "speech-category",
                                  style: _normalizeStyle(_ctx.getColorCSS(speech))
                                }, _toDisplayString(speech.category), 5))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_26, [
                              _createElementVNode("span", _hoisted_27, [
                                _createTextVNode(_toDisplayString(speech.title) + " ", 1),
                                (_ctx.enableFavorites)
                                  ? (_openBlock(), _createElementBlock("i", {
                                      key: 0,
                                      class: _normalizeClass([_ctx.isFavorite(speech) ? 'fas': 'far', "fa-star"]),
                                      onClick: ($event: any) => (_ctx.toggleFavorite(speech,$event))
                                    }, null, 10, _hoisted_28))
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("div", {
                                class: "ical-button",
                                onClick: ($event: any) => (_ctx.downloadIcal(speech,$event))
                              }, _cache[13] || (_cache[13] = [
                                _createTextVNode(" iCAL "),
                                _createElementVNode("i", { class: "fa fa-arrow-down fa-1x" }, null, -1)
                              ]), 8, _hoisted_29)
                            ]),
                            (!speech.showInfoInsteadOfSpeakers())
                              ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                                  (speech.persons.length > 0)
                                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.roles, (role) => {
                                        return (_openBlock(), _createElementBlock(_Fragment, null, [
                                          (speech.hasSpeakerWithRole(role))
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                                                _createElementVNode("div", _hoisted_32, [
                                                  _createElementVNode("span", _hoisted_33, _toDisplayString(speech.getPersonsByRole(role).length > 1 ? role.displayNamePlural : role.displayNameSingular) + ": ", 1),
                                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(speech.getPersonsByRole(role), (s) => {
                                                    return (_openBlock(), _createElementBlock("div", {
                                                      class: "speaker",
                                                      set: _ctx.speaker=_ctx.getSpeakerById(s.id)
                                                    }, [
                                                      (_ctx.speaker.displayName)
                                                        ? (_openBlock(), _createElementBlock("span", {
                                                            key: 0,
                                                            class: "speaker-name",
                                                            onClick: ($event: any) => (_ctx.openSpeakerDetailDialog(_ctx.getSpeakerById(s.id),$event))
                                                          }, [
                                                            _createTextVNode(_toDisplayString(_ctx.speaker.displayName), 1),
                                                            (_ctx.speaker.position || _ctx.speaker.company || _ctx.speaker.country)
                                                              ? (_openBlock(), _createElementBlock("span", _hoisted_36, ","))
                                                              : _createCommentVNode("", true)
                                                          ], 8, _hoisted_35))
                                                        : _createCommentVNode("", true),
                                                      (_ctx.speaker.position)
                                                        ? (_openBlock(), _createElementBlock("span", _hoisted_37, [
                                                            _createTextVNode(_toDisplayString(_ctx.speaker.position), 1),
                                                            (_ctx.speaker.company || _ctx.speaker.country)
                                                              ? (_openBlock(), _createElementBlock("span", _hoisted_38, ","))
                                                              : _createCommentVNode("", true)
                                                          ]))
                                                        : _createCommentVNode("", true),
                                                      (_ctx.speaker.company)
                                                        ? (_openBlock(), _createElementBlock("span", _hoisted_39, [
                                                            _createTextVNode(_toDisplayString(_ctx.speaker.company), 1),
                                                            (_ctx.speaker.country)
                                                              ? (_openBlock(), _createElementBlock("span", _hoisted_40, ","))
                                                              : _createCommentVNode("", true)
                                                          ]))
                                                        : _createCommentVNode("", true),
                                                      (_ctx.speaker.country)
                                                        ? (_openBlock(), _createElementBlock("span", _hoisted_41, _toDisplayString(_ctx.speaker.country), 1))
                                                        : _createCommentVNode("", true)
                                                    ], 8, _hoisted_34))
                                                  }), 256))
                                                ]),
                                                _createElementVNode("div", _hoisted_42, [
                                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(speech.getPersonsByRole(role), (s) => {
                                                    return (_openBlock(), _createBlock(_component_lazy_load_container, null, {
                                                      default: _withCtx(() => [
                                                        _createElementVNode("div", {
                                                          onClick: ($event: any) => (_ctx.openSpeakerDetailDialog(_ctx.getSpeakerById(s.id),$event)),
                                                          title: _ctx.getSpeakerById(s.id).displayName,
                                                          style: _normalizeStyle([_ctx.getSpeakerById(s.id).hasPicture() ? {'background-image':'url('+ _ctx.getSpeakerById(s.id).getPictureUrl()+')'} : {} ])
                                                        }, null, 12, _hoisted_43)
                                                      ]),
                                                      _: 2
                                                    }, 1024))
                                                  }), 256))
                                                ])
                                              ]))
                                            : _createCommentVNode("", true)
                                        ], 64))
                                      }), 256))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true),
                            (!speech.showInfoInsteadOfSpeakers() && speech.info !== undefined && speech.info.length > 0)
                              ? (_openBlock(), _createElementBlock("div", {
                                  key: 2,
                                  class: "speech-info",
                                  innerHTML: speech.info
                                }, null, 8, _hoisted_44))
                              : _createCommentVNode("", true),
                            (speech.showInfoInsteadOfSpeakers())
                              ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                                  _createElementVNode("div", _hoisted_46, [
                                    _createElementVNode("div", {
                                      class: "speaker-list",
                                      innerHTML: speech.info
                                    }, null, 8, _hoisted_47),
                                    _createElementVNode("div", _hoisted_48, [
                                      (speech.persons.length > 0)
                                        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.roles, (role, index) => {
                                            return (_openBlock(), _createElementBlock(_Fragment, null, [
                                              (speech.hasSpeakerWithRole(role))
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(speech.getPersonsByRole(role), (s) => {
                                                      return (_openBlock(), _createBlock(_component_lazy_load_container, null, {
                                                        default: _withCtx(() => [
                                                          _createElementVNode("div", {
                                                            onClick: ($event: any) => (_ctx.openSpeakerDetailDialog(_ctx.getSpeakerById(s.id),$event)),
                                                            title: _ctx.getSpeakerById(s.id).displayName,
                                                            style: _normalizeStyle([_ctx.getSpeakerById(s.id).hasPicture() ? {'background-image':'url('+ _ctx.getSpeakerById(s.id).getPictureUrl()+')'} : {} ])
                                                          }, null, 12, _hoisted_50)
                                                        ]),
                                                        _: 2
                                                      }, 1024))
                                                    }), 256))
                                                  ]))
                                                : _createCommentVNode("", true)
                                            ], 64))
                                          }), 256))
                                        : _createCommentVNode("", true)
                                    ])
                                  ])
                                ]))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_51, [
                              _createElementVNode("div", _hoisted_52, [
                                _createElementVNode("i", {
                                  class: "fas fa-clock",
                                  style: _normalizeStyle(_ctx.getIconColorCSS(speech))
                                }, null, 4),
                                _createTextVNode(" " + _toDisplayString(speech.timeSpan), 1)
                              ]),
                              _createElementVNode("div", {
                                class: _normalizeClass(_ctx.$haveMaps && speech.stands.length > 0 ? 'speech-place':''),
                                onClick: ($event: any) => (_ctx.$haveMaps && speech.stands.length > 0 ? _ctx.openStandDialog(speech.stands[0],$event) : {})
                              }, [
                                _createElementVNode("i", {
                                  class: "fas fa-map-marker-alt",
                                  style: _normalizeStyle(_ctx.getIconColorCSS(speech))
                                }, null, 4),
                                _createTextVNode(" " + _toDisplayString(speech.place), 1)
                              ], 10, _hoisted_53),
                              (speech.languageID)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                                    _createElementVNode("i", {
                                      class: "fas fa-comment-alt-lines",
                                      style: _normalizeStyle(_ctx.getIconColorCSS(speech))
                                    }, null, 4),
                                    _createTextVNode(" " + _toDisplayString(_ctx.getLangForSpeechById(speech.languageID)), 1)
                                  ]))
                                : _createCommentVNode("", true),
                              (speech.exhibitorName)
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 1,
                                    class: "speech-exhibitor",
                                    onClick: ($event: any) => (_ctx.openExhibitorDialog(speech.exhibitorId,$event))
                                  }, _toDisplayString(_ctx.$t("organizer")) + " " + _toDisplayString(speech.exhibitorName), 9, _hoisted_55))
                                : _createCommentVNode("", true),
                              (speech.hasTranslation)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                                    _createElementVNode("i", {
                                      class: "fas fa-headphones-alt",
                                      style: _normalizeStyle(_ctx.getIconColorCSS(speech))
                                    }, null, 4),
                                    _createTextVNode(" " + _toDisplayString(_ctx.$t("translate")), 1)
                                  ]))
                                : _createCommentVNode("", true),
                              (speech.logo)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                                    (!_ctx.acomSpecialIds.includes(speech.id))
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_58, _toDisplayString(_ctx.$t('in-cooperation-with')), 1))
                                      : (_openBlock(), _createElementBlock("span", _hoisted_59, _toDisplayString(_ctx.$t('organized-by')), 1)),
                                    _createVNode(_component_lazy_load_container, null, {
                                      default: _withCtx(() => [
                                        _createElementVNode("img", {
                                          src: speech.getLogoUrl()
                                        }, null, 8, _hoisted_60)
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ], 4)
                        ])
                      ], 8, _hoisted_20))
                    }), 256))
                  ]))
                }), 256))
              : _createCommentVNode("", true),
            (_ctx.speechContainer && !_ctx.speechContainer.hasEntries())
              ? (_openBlock(), _createElementBlock("span", _hoisted_61, _toDisplayString(_ctx.$t("empty-search-results")), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", {
            ref: "scrollToTopButton",
            class: "scroll-to-top-button",
            onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.scrollTop && _ctx.scrollTop(...args)))
          }, _cache[14] || (_cache[14] = [
            _createElementVNode("svg", {
              xmlns: "http://www.w3.org/2000/svg",
              fill: "white",
              viewBox: "0 0 448 512"
            }, [
              _createElementVNode("path", { d: "M34.9 289.5l-22.2-22.2c-9.4-9.4-9.4-24.6 0-33.9L207 39c9.4-9.4 24.6-9.4 33.9 0l194.3 194.3c9.4 9.4 9.4 24.6 0 33.9L413 289.4c-9.5 9.5-25 9.3-34.3-.4L264 168.6V456c0 13.3-10.7 24-24 24h-32c-13.3 0-24-10.7-24-24V168.6L69.2 289.1c-9.3 9.8-24.8 10-34.3.4z" })
            ], -1)
          ]), 512)
        ], 64))
      : _createCommentVNode("", true)
  ]))
}